<template>
  <div class="audienceContainer">
    <h2 class="mb-0" :style="{'font-size': $vuetify.breakpoint.smAndDown ? '20px' : '24px'}">Audience</h2>
    <v-radio-group v-model="audience" :rules="audienceRule" row class="mt-0">
      <v-radio v-for="option in audienceOptions"
               :key="option.code"
               :label="option.label"
               :value="option.code"
               :class="'radioButton radioButtonAudience radio' + option.code"
               color="primary"
      >
        <template v-slot:label>
                  <span class="d-flex align-center">
                    <v-icon
                      large
                      class="pl-1 pr-1"
                      color="primary"
                    >
                      {{ option.icon }}
                    </v-icon>
                    <span class="mb-0 ml-2">{{ option.label }}</span>
                  </span>
        </template>
      </v-radio>
    </v-radio-group>

    <v-chip
      v-if="this.audienceIndividualsPayload.length > 1000 && 
            this.audienceIndividualsPayload.length <= 20000 && 
            audience === 'Individuals'"
      class="ma-2"
      close
      close-icon="mdi-delete"
      label
      color="green"
      outlined
      x-large
      @click:close="clearAudiences"
    >
      You have successfully uploaded {{ this.audienceIndividualsPayload.length }} audience members.
    </v-chip>
    <v-chip
      v-if="this.audienceIndividualsPayload.length > 20000 && audience === 'Individuals'"
      class="ma-2"
      close
      close-icon="mdi-delete"
      label
      color="red"
      outlined
      x-large
      @click:close="clearAudiences"
    >
      You have uploaded more than 20,000 audience members.
    </v-chip>
    <div
      id="individual-input-box"
      v-if="this.audienceIndividualsPayload.length <= 1000 && audience === 'Individuals'"
    >
      <v-combobox
        v-model="audienceIndividualsPayload"
        :items="audienceIndividualsPayload"
        :search-input.sync="search"
        label="Enter DOE User ID"
        placeholder="e.g. john.doe"
        hide-selected
        multiple
        chips
        outlined
        @paste.native="pastedUserIds"
        :rules="audienceIndividualsRule"
        class="mt-6"
        clearable
      >
        <template v-slot:selection="{ attrs, item, select, selected }">
          <v-chip
            :key="componentKey + item"
            v-bind="attrs"
            :input-value="selected"
            close
            @click="select"
            @click:close="remove(item)"
            :class="{
                  'invalid': audiencePayloadState[item] &&
                    !audiencePayloadState[item].isLoading &&
                    !audiencePayloadState[item].isValid,
                  'loading': audiencePayloadState[item] &&
                  audiencePayloadState[item].isLoading
                  }">
            <span>{{ item }}</span>
          </v-chip>
        </template>
      </v-combobox>
      <h3>Or specify users from a CSV</h3>
      <v-col cols="8" class="pl-0">
        <CsvFileInput @change="handleFileUpload"/>
      </v-col>

    </div>

  </div>
</template>

<script>
import {QPLUS_AUDIENCE} from '@/static/data';
import checkUserApi from "api-client/checkUser";
import CsvFileInput from './CsvFileInput';
import Papa from 'papaparse';

export default {
  name: 'Audience',
  components: {
    CsvFileInput
  },
  data() {
    // const audiencePayload = this.$store.getters.notificationAudienceAndScheduling.audience.payload;
    const audiencePayload = null;
    return {
      audienceOptions: QPLUS_AUDIENCE,
      audience: 'Individuals',
      audienceIndividualsPayload: this.audience === 'Individuals' && audiencePayload ? audiencePayload : [],
      audienceIndividualsRule: [],
      loadingCount: 0,
      search: "",
      audiencePayloadState: {},
      componentKey: 0,
      isFromCsv: false,
    }
  },
  computed: {
    audienceRule() {
      const rule = [this.audience !== null || 'Please, select an audience option'];
      this.$emit('audienceRule', rule);
      return rule;
    }
  },
  watch: {
    search: function (newValue, oldValue) {
      if (oldValue === '') {
        return;
      }
      const breakers = [' ', ';', ',']

      if (this.search && this.search.trim() !== '' && breakers.includes(newValue.substring(newValue.length - 1))) {
        let item = newValue.substring(0, newValue.length - 1).trim();
        if (this.audience === 'Individuals' && !this.audienceIndividualsPayload.includes(item)) this.audienceIndividualsPayload.push(item);
        this.search = '';
      }
    },
    audienceIndividualsPayload(newAudiencePayload) {
      // prevent check user endpoint to perform a search - which happens if an asterisk is added at the end of the user id
      if (newAudiencePayload.some(i => i[i.length - 1] === '*')) {
        this.audienceIndividualsPayload = newAudiencePayload.map(i => {
          if (i[i.length - 1] === '*') {
            return i.substr(0, i.length - 1);
          } else {
            return i;
          }
        })

        return;
      }

      /* 
        only check audience validation when payload is not from CSV (when CSV file is not loaded) 
        and the number of audiences is not greater than 10 (esp. in review)
      */
      if (!this.isFromCsv && newAudiencePayload.length <= 10) {
        newAudiencePayload.forEach(i => {
          if (!this.audiencePayloadState[i]) {
            this.loadingCount += 1;
            this.audiencePayloadState[i] = {
              isLoading: true,
              isValid: null
            }
            this.checkAudienceValidation(i);
          }
        })
      }
      
      this.handleIndividualsRule();
      
      this.$emit('audiencePayload', newAudiencePayload);
    },
    audience() {
      this.$emit('audience', this.audience);
      if (this.audience === 'Individuals') {
        this.$emit('audiencePayloadRule', this.audienceIndividualsRule);
        this.$emit('audiencePayload', this.audienceIndividualsPayload);
      }
    },
    loadingCount(val) {
      if (val > 0) {
        this.$emit('audienceLoading', true);
      } else {
        this.$emit('audienceLoading', false);
      }
    }
  },
  methods: {
    checkAudienceValidation(item) {
      if (this.audience === 'Individuals') {
        this.checkUser(item).then(isValid => {
          this.audiencePayloadState[item].isLoading = false;
          this.audiencePayloadState[item].isValid = isValid;
          this.componentKey++;
        })
          .finally(() => {
            this.loadingCount -= 1;
            this.handleIndividualsRule();
          })
      }
    },
    async checkUser(user) {
      return await checkUserApi.checkUsername(user)
        .catch(err => {
          console.error(err);
          return false;
        });
    },
    handleIndividualsRule() {
      let rule = [true];
      let notValid;
      notValid = this.audienceIndividualsPayload.some(i => {
        if (this.audiencePayloadState[i]) {
          return this.audiencePayloadState[i].isValid === false;
        } else {
          return false;
        }
      });
      if (notValid) {
        rule = ['Please, select valid DoE user IDs'];
      }
      if (this.audienceIndividualsPayload.length === 0) {
        rule = ['Please, select at least one option'];
      }
      if (this.audienceIndividualsPayload.length > 20000) {
        rule = ['Maximum 20,000 recipients']
      }
      this.$emit('audiencePayloadRule', rule);
      this.audienceIndividualsRule = rule;
    },
    handleFileUpload(files) {
      if(files && files.length > 0) {
        Promise.allSettled(files.map(file => this.parseCsv(file)))
          .then(promises => promises.map(p => p.value))
          .then(files => {
            const allNames = files.reduce((allNames, file) => {
              file && file.forEach(name => {
                allNames.add(name);
              })
              return allNames;
            }, new Set());
            return allNames;
          })
          .then((allNames) => {
            this.isFromCsv = true;
            this.audienceIndividualsPayload = Array.from(allNames);
          });
      }
    },
    parseCsv(file) {
      const promise = new Promise((resolve) => {
        Papa.parse(file, {
          skipEmptyLines: 'greedy',
          complete: (result) => {
            if(result.data.length > 0) {
              const names = result.data.reduce((names, line) => names.concat(line.filter(item => item.length > 0)), []);
              resolve(names);
            }
          }
        });
      });

      return promise;
    },

    remove(item) {
      if (this.audience === 'Individuals') {
        this.audienceIndividualsPayload.splice(this.audienceIndividualsPayload.indexOf(item), 1)
        this.audienceIndividualsPayload = [...this.audienceIndividualsPayload]
      }
    },
    pastedUserIds() {
      setTimeout(() => {
        if (this.audience === 'Individuals') {
          this.audienceIndividualsPayload
            .push(...this.search.split(",")
              .filter(item => !(item.length === 0 || !item.trim())));
        }
        this.search = "";
      });
    },
    clearAudiences() {
      if (this.audience === 'Individuals') {
        this.audienceIndividualsPayload = [];
      }
    },
    fixComboboxHeight() {
      const comboboxInput = this.$el.querySelector('#individual-input-box .v-input__control .v-select__slot .v-select__selections');
      comboboxInput.style.cssText += `
        max-height: 490px;
        overflow: auto;
      `;
    }
  },
  created() {
    if (this.$store.getters.currentNotification && this.$store.getters.notificationAudienceAndScheduling.audience.type) {
      this.audience = this.$store.getters.notificationAudienceAndScheduling.audience.type;
      if (this.$store.getters.notificationAudienceAndScheduling.audience.type === 'Individuals') {
        this.audienceIndividualsPayload = this.$store.getters.notificationAudienceAndScheduling.audience.emails.map(email => {
          let splitEmail = email.split('@');
          return splitEmail[0];
        });
      }
    }
  },
  updated() {
    this.fixComboboxHeight();
  }
}
</script>

<style lang="scss" scoped>
::v-deep.v-input--radio-group--row .v-input--radio-group__input {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  & > :first-child {
    margin-right: 1rem;
  }
}

.radioButton {
  border: 1px solid #6D7079;
  border-radius: 4px;
  padding: 20px;
  height: 100px;
  margin-top: 24px;
}

.radioButtonAudience {
  width: calc(100% / 3 - 12px);
}

@media only screen and (max-width: 960px) {
  .radioButtonAudience {
    width: calc(100% / 2 - 12px);
  }
  ::v-deep.v-input--radio-group--row .v-input--radio-group__input {
    justify-content: space-between;
  }
}

@media only screen and (max-width: 600px) {
  .radioButtonAudience {
    width: 100%;
  }
}

.radioEveryone {
  margin-right: 0 !important;
}

.v-item--active {
  border: 2px solid #041E42;
  background-color: #DADADA;
}

.v-chip {
  background-color: #C8DCF0 !important;
  border: 1px solid #041E42;
}

.v-chip.loading {
  opacity: 0.5;
}

.v-chip.invalid {
  background-color: #B91237 !important;
  border: none;
  color: #FFFFFF;

  ::v-deep .v-chip__content button.v-icon {
    color: #FFFFFF;
  }
}

::v-deep.v-list.theme--light .v-list-item.v-list-item--active {
  color: #041E42 !important;
}
</style>
